import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { useAuth } from './AuthContext';

const AdminLogin = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0B] pt-32 pb-16 px-6" data-testid="admin-login">
      <div className="max-w-sm mx-auto">
        <div className="flex flex-col items-center mb-10">
          <div className="w-12 h-12 flex items-center justify-center border border-[#14B8A6]/30 rounded-full mb-5">
            <Lock className="w-5 h-5 text-[#14B8A6]" strokeWidth={1.5} />
          </div>
          <p className="label-sm text-[#14B8A6] mb-3" data-font="label">Admin Access</p>
          <h1 className="text-3xl font-medium text-[#F0EDE8]">Sign in</h1>
        </div>

        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <label htmlFor="admin-email" className="block text-xs uppercase tracking-[0.12em] text-[#E8E4DF]/50 mb-2" data-font="label">Email</label>
            <input
              id="admin-email"
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#0f0b18] border border-[#3d2a5c]/25 px-4 py-3 text-[#F0EDE8] focus:outline-none focus:border-[#14B8A6]/50 transition-colors"
              data-testid="admin-email-input"
            />
          </div>

          <div>
            <label htmlFor="admin-password" className="block text-xs uppercase tracking-[0.12em] text-[#E8E4DF]/50 mb-2" data-font="label">Password</label>
            <input
              id="admin-password"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#0f0b18] border border-[#3d2a5c]/25 px-4 py-3 text-[#F0EDE8] focus:outline-none focus:border-[#14B8A6]/50 transition-colors"
              data-testid="admin-password-input"
            />
          </div>

          {error && (
            <p className="text-red-400 text-sm" data-testid="admin-login-error">{error}</p>
          )}

          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-[#14B8A6] hover:bg-[#0D9488] disabled:opacity-50 disabled:cursor-not-allowed text-[#0A0A0B] font-medium py-3.5 text-sm uppercase tracking-[0.12em] transition-colors"
            data-testid="admin-login-submit"
            data-font="label"
          >
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
